import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable()
export class PageLoaderService {
  private pageLoaderSource = new BehaviorSubject<any>({});

  pageLoader = this.pageLoaderSource.asObservable();

  constructor() { }

  addPageLoader(pageLoader: any) {
    this.pageLoaderSource.next(pageLoader);
  }
}
